/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SpacesIndexRouteImport } from './routes/spaces/index'
import { Route as SpacesTrialRouteImport } from './routes/spaces/trial'
import { Route as SpacesTicketRouteImport } from './routes/spaces/ticket'
import { Route as SpacesTemplatesListRouteImport } from './routes/spaces/templates-list'
import { Route as SpacesTemplateRouteImport } from './routes/spaces/template'
import { Route as SpacesSettingsRouteImport } from './routes/spaces/settings'
import { Route as SpacesConnectRouteImport } from './routes/spaces/connect'
import { Route as SpacesClassicRouteImport } from './routes/spaces/classic'
import { Route as SpacesCheckMailRouteImport } from './routes/spaces/check-mail'
import { Route as Spaces404RouteImport } from './routes/spaces/404'
import { Route as SpacesExternalRouteRouteImport } from './routes/spaces/external/route'
import { Route as SpacesLicenseManagerSaasLayoutRouteImport } from './routes/spaces/license-manager/_saasLayout'
import { Route as SpacesExternalIntegrationsRouteImport } from './routes/spaces/external/integrations'
import { Route as SpacesExternalClassicRouteImport } from './routes/spaces/external/classic'
import { Route as SpacesauthLogoutRouteImport } from './routes/spaces/(auth)/logout'
import { Route as SpacesauthLoginRouteImport } from './routes/spaces/(auth)/login'
import { Route as SpacesauthForgotPasswordRouteImport } from './routes/spaces/(auth)/forgot-password'
import { Route as SpacesLicenseManagerSaasLayoutIndexRouteImport } from './routes/spaces/license-manager/_saasLayout.index'
import { Route as SpacesLicenseManagerSaasLayoutDiscoveryRouteImport } from './routes/spaces/license-manager/_saasLayout.discovery'

const SpacesLicenseManagerRouteImport = createFileRoute(
  '/spaces/license-manager',
)()

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SpacesLicenseManagerRoute = SpacesLicenseManagerRouteImport.update({
  id: '/spaces/license-manager',
  path: '/spaces/license-manager',
  getParentRoute: () => rootRouteImport,
} as any)
const SpacesIndexRoute = SpacesIndexRouteImport.update({
  id: '/spaces/',
  path: '/spaces/',
  getParentRoute: () => rootRouteImport,
} as any)
const SpacesTrialRoute = SpacesTrialRouteImport.update({
  id: '/spaces/trial',
  path: '/spaces/trial',
  getParentRoute: () => rootRouteImport,
} as any)
const SpacesTicketRoute = SpacesTicketRouteImport.update({
  id: '/spaces/ticket',
  path: '/spaces/ticket',
  getParentRoute: () => rootRouteImport,
} as any)
const SpacesTemplatesListRoute = SpacesTemplatesListRouteImport.update({
  id: '/spaces/templates-list',
  path: '/spaces/templates-list',
  getParentRoute: () => rootRouteImport,
} as any)
const SpacesTemplateRoute = SpacesTemplateRouteImport.update({
  id: '/spaces/template',
  path: '/spaces/template',
  getParentRoute: () => rootRouteImport,
} as any)
const SpacesSettingsRoute = SpacesSettingsRouteImport.update({
  id: '/spaces/settings',
  path: '/spaces/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SpacesConnectRoute = SpacesConnectRouteImport.update({
  id: '/spaces/connect',
  path: '/spaces/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const SpacesClassicRoute = SpacesClassicRouteImport.update({
  id: '/spaces/classic',
  path: '/spaces/classic',
  getParentRoute: () => rootRouteImport,
} as any)
const SpacesCheckMailRoute = SpacesCheckMailRouteImport.update({
  id: '/spaces/check-mail',
  path: '/spaces/check-mail',
  getParentRoute: () => rootRouteImport,
} as any)
const Spaces404Route = Spaces404RouteImport.update({
  id: '/spaces/404',
  path: '/spaces/404',
  getParentRoute: () => rootRouteImport,
} as any)
const SpacesExternalRouteRoute = SpacesExternalRouteRouteImport.update({
  id: '/spaces/external',
  path: '/spaces/external',
  getParentRoute: () => rootRouteImport,
} as any)
const SpacesLicenseManagerSaasLayoutRoute =
  SpacesLicenseManagerSaasLayoutRouteImport.update({
    id: '/_saasLayout',
    getParentRoute: () => SpacesLicenseManagerRoute,
  } as any)
const SpacesExternalIntegrationsRoute =
  SpacesExternalIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => SpacesExternalRouteRoute,
  } as any)
const SpacesExternalClassicRoute = SpacesExternalClassicRouteImport.update({
  id: '/classic',
  path: '/classic',
  getParentRoute: () => SpacesExternalRouteRoute,
} as any)
const SpacesauthLogoutRoute = SpacesauthLogoutRouteImport.update({
  id: '/spaces/(auth)/logout',
  path: '/spaces/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const SpacesauthLoginRoute = SpacesauthLoginRouteImport.update({
  id: '/spaces/(auth)/login',
  path: '/spaces/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SpacesauthForgotPasswordRoute =
  SpacesauthForgotPasswordRouteImport.update({
    id: '/spaces/(auth)/forgot-password',
    path: '/spaces/forgot-password',
    getParentRoute: () => rootRouteImport,
  } as any)
const SpacesLicenseManagerSaasLayoutIndexRoute =
  SpacesLicenseManagerSaasLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SpacesLicenseManagerSaasLayoutRoute,
  } as any)
const SpacesLicenseManagerSaasLayoutDiscoveryRoute =
  SpacesLicenseManagerSaasLayoutDiscoveryRouteImport.update({
    id: '/discovery',
    path: '/discovery',
    getParentRoute: () => SpacesLicenseManagerSaasLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/spaces/external': typeof SpacesExternalRouteRouteWithChildren
  '/spaces/404': typeof Spaces404Route
  '/spaces/check-mail': typeof SpacesCheckMailRoute
  '/spaces/classic': typeof SpacesClassicRoute
  '/spaces/connect': typeof SpacesConnectRoute
  '/spaces/settings': typeof SpacesSettingsRoute
  '/spaces/template': typeof SpacesTemplateRoute
  '/spaces/templates-list': typeof SpacesTemplatesListRoute
  '/spaces/ticket': typeof SpacesTicketRoute
  '/spaces/trial': typeof SpacesTrialRoute
  '/spaces': typeof SpacesIndexRoute
  '/spaces/forgot-password': typeof SpacesauthForgotPasswordRoute
  '/spaces/login': typeof SpacesauthLoginRoute
  '/spaces/logout': typeof SpacesauthLogoutRoute
  '/spaces/external/classic': typeof SpacesExternalClassicRoute
  '/spaces/external/integrations': typeof SpacesExternalIntegrationsRoute
  '/spaces/license-manager': typeof SpacesLicenseManagerSaasLayoutRouteWithChildren
  '/spaces/license-manager/discovery': typeof SpacesLicenseManagerSaasLayoutDiscoveryRoute
  '/spaces/license-manager/': typeof SpacesLicenseManagerSaasLayoutIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/spaces/external': typeof SpacesExternalRouteRouteWithChildren
  '/spaces/404': typeof Spaces404Route
  '/spaces/check-mail': typeof SpacesCheckMailRoute
  '/spaces/classic': typeof SpacesClassicRoute
  '/spaces/connect': typeof SpacesConnectRoute
  '/spaces/settings': typeof SpacesSettingsRoute
  '/spaces/template': typeof SpacesTemplateRoute
  '/spaces/templates-list': typeof SpacesTemplatesListRoute
  '/spaces/ticket': typeof SpacesTicketRoute
  '/spaces/trial': typeof SpacesTrialRoute
  '/spaces': typeof SpacesIndexRoute
  '/spaces/forgot-password': typeof SpacesauthForgotPasswordRoute
  '/spaces/login': typeof SpacesauthLoginRoute
  '/spaces/logout': typeof SpacesauthLogoutRoute
  '/spaces/external/classic': typeof SpacesExternalClassicRoute
  '/spaces/external/integrations': typeof SpacesExternalIntegrationsRoute
  '/spaces/license-manager': typeof SpacesLicenseManagerSaasLayoutIndexRoute
  '/spaces/license-manager/discovery': typeof SpacesLicenseManagerSaasLayoutDiscoveryRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/spaces/external': typeof SpacesExternalRouteRouteWithChildren
  '/spaces/404': typeof Spaces404Route
  '/spaces/check-mail': typeof SpacesCheckMailRoute
  '/spaces/classic': typeof SpacesClassicRoute
  '/spaces/connect': typeof SpacesConnectRoute
  '/spaces/settings': typeof SpacesSettingsRoute
  '/spaces/template': typeof SpacesTemplateRoute
  '/spaces/templates-list': typeof SpacesTemplatesListRoute
  '/spaces/ticket': typeof SpacesTicketRoute
  '/spaces/trial': typeof SpacesTrialRoute
  '/spaces/': typeof SpacesIndexRoute
  '/spaces/(auth)/forgot-password': typeof SpacesauthForgotPasswordRoute
  '/spaces/(auth)/login': typeof SpacesauthLoginRoute
  '/spaces/(auth)/logout': typeof SpacesauthLogoutRoute
  '/spaces/external/classic': typeof SpacesExternalClassicRoute
  '/spaces/external/integrations': typeof SpacesExternalIntegrationsRoute
  '/spaces/license-manager': typeof SpacesLicenseManagerRouteWithChildren
  '/spaces/license-manager/_saasLayout': typeof SpacesLicenseManagerSaasLayoutRouteWithChildren
  '/spaces/license-manager/_saasLayout/discovery': typeof SpacesLicenseManagerSaasLayoutDiscoveryRoute
  '/spaces/license-manager/_saasLayout/': typeof SpacesLicenseManagerSaasLayoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/spaces/external'
    | '/spaces/404'
    | '/spaces/check-mail'
    | '/spaces/classic'
    | '/spaces/connect'
    | '/spaces/settings'
    | '/spaces/template'
    | '/spaces/templates-list'
    | '/spaces/ticket'
    | '/spaces/trial'
    | '/spaces'
    | '/spaces/forgot-password'
    | '/spaces/login'
    | '/spaces/logout'
    | '/spaces/external/classic'
    | '/spaces/external/integrations'
    | '/spaces/license-manager'
    | '/spaces/license-manager/discovery'
    | '/spaces/license-manager/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/spaces/external'
    | '/spaces/404'
    | '/spaces/check-mail'
    | '/spaces/classic'
    | '/spaces/connect'
    | '/spaces/settings'
    | '/spaces/template'
    | '/spaces/templates-list'
    | '/spaces/ticket'
    | '/spaces/trial'
    | '/spaces'
    | '/spaces/forgot-password'
    | '/spaces/login'
    | '/spaces/logout'
    | '/spaces/external/classic'
    | '/spaces/external/integrations'
    | '/spaces/license-manager'
    | '/spaces/license-manager/discovery'
  id:
    | '__root__'
    | '/'
    | '/spaces/external'
    | '/spaces/404'
    | '/spaces/check-mail'
    | '/spaces/classic'
    | '/spaces/connect'
    | '/spaces/settings'
    | '/spaces/template'
    | '/spaces/templates-list'
    | '/spaces/ticket'
    | '/spaces/trial'
    | '/spaces/'
    | '/spaces/(auth)/forgot-password'
    | '/spaces/(auth)/login'
    | '/spaces/(auth)/logout'
    | '/spaces/external/classic'
    | '/spaces/external/integrations'
    | '/spaces/license-manager'
    | '/spaces/license-manager/_saasLayout'
    | '/spaces/license-manager/_saasLayout/discovery'
    | '/spaces/license-manager/_saasLayout/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SpacesExternalRouteRoute: typeof SpacesExternalRouteRouteWithChildren
  Spaces404Route: typeof Spaces404Route
  SpacesCheckMailRoute: typeof SpacesCheckMailRoute
  SpacesClassicRoute: typeof SpacesClassicRoute
  SpacesConnectRoute: typeof SpacesConnectRoute
  SpacesSettingsRoute: typeof SpacesSettingsRoute
  SpacesTemplateRoute: typeof SpacesTemplateRoute
  SpacesTemplatesListRoute: typeof SpacesTemplatesListRoute
  SpacesTicketRoute: typeof SpacesTicketRoute
  SpacesTrialRoute: typeof SpacesTrialRoute
  SpacesIndexRoute: typeof SpacesIndexRoute
  SpacesauthForgotPasswordRoute: typeof SpacesauthForgotPasswordRoute
  SpacesauthLoginRoute: typeof SpacesauthLoginRoute
  SpacesauthLogoutRoute: typeof SpacesauthLogoutRoute
  SpacesLicenseManagerRoute: typeof SpacesLicenseManagerRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/license-manager': {
      id: '/spaces/license-manager'
      path: '/spaces/license-manager'
      fullPath: '/spaces/license-manager'
      preLoaderRoute: typeof SpacesLicenseManagerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/': {
      id: '/spaces/'
      path: '/spaces'
      fullPath: '/spaces'
      preLoaderRoute: typeof SpacesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/trial': {
      id: '/spaces/trial'
      path: '/spaces/trial'
      fullPath: '/spaces/trial'
      preLoaderRoute: typeof SpacesTrialRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/ticket': {
      id: '/spaces/ticket'
      path: '/spaces/ticket'
      fullPath: '/spaces/ticket'
      preLoaderRoute: typeof SpacesTicketRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/templates-list': {
      id: '/spaces/templates-list'
      path: '/spaces/templates-list'
      fullPath: '/spaces/templates-list'
      preLoaderRoute: typeof SpacesTemplatesListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/template': {
      id: '/spaces/template'
      path: '/spaces/template'
      fullPath: '/spaces/template'
      preLoaderRoute: typeof SpacesTemplateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/settings': {
      id: '/spaces/settings'
      path: '/spaces/settings'
      fullPath: '/spaces/settings'
      preLoaderRoute: typeof SpacesSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/connect': {
      id: '/spaces/connect'
      path: '/spaces/connect'
      fullPath: '/spaces/connect'
      preLoaderRoute: typeof SpacesConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/classic': {
      id: '/spaces/classic'
      path: '/spaces/classic'
      fullPath: '/spaces/classic'
      preLoaderRoute: typeof SpacesClassicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/check-mail': {
      id: '/spaces/check-mail'
      path: '/spaces/check-mail'
      fullPath: '/spaces/check-mail'
      preLoaderRoute: typeof SpacesCheckMailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/404': {
      id: '/spaces/404'
      path: '/spaces/404'
      fullPath: '/spaces/404'
      preLoaderRoute: typeof Spaces404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/external': {
      id: '/spaces/external'
      path: '/spaces/external'
      fullPath: '/spaces/external'
      preLoaderRoute: typeof SpacesExternalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/license-manager/_saasLayout': {
      id: '/spaces/license-manager/_saasLayout'
      path: '/spaces/license-manager'
      fullPath: '/spaces/license-manager'
      preLoaderRoute: typeof SpacesLicenseManagerSaasLayoutRouteImport
      parentRoute: typeof SpacesLicenseManagerRoute
    }
    '/spaces/external/integrations': {
      id: '/spaces/external/integrations'
      path: '/integrations'
      fullPath: '/spaces/external/integrations'
      preLoaderRoute: typeof SpacesExternalIntegrationsRouteImport
      parentRoute: typeof SpacesExternalRouteRoute
    }
    '/spaces/external/classic': {
      id: '/spaces/external/classic'
      path: '/classic'
      fullPath: '/spaces/external/classic'
      preLoaderRoute: typeof SpacesExternalClassicRouteImport
      parentRoute: typeof SpacesExternalRouteRoute
    }
    '/spaces/(auth)/logout': {
      id: '/spaces/(auth)/logout'
      path: '/spaces/logout'
      fullPath: '/spaces/logout'
      preLoaderRoute: typeof SpacesauthLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/(auth)/login': {
      id: '/spaces/(auth)/login'
      path: '/spaces/login'
      fullPath: '/spaces/login'
      preLoaderRoute: typeof SpacesauthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/(auth)/forgot-password': {
      id: '/spaces/(auth)/forgot-password'
      path: '/spaces/forgot-password'
      fullPath: '/spaces/forgot-password'
      preLoaderRoute: typeof SpacesauthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces/license-manager/_saasLayout/': {
      id: '/spaces/license-manager/_saasLayout/'
      path: '/'
      fullPath: '/spaces/license-manager/'
      preLoaderRoute: typeof SpacesLicenseManagerSaasLayoutIndexRouteImport
      parentRoute: typeof SpacesLicenseManagerSaasLayoutRoute
    }
    '/spaces/license-manager/_saasLayout/discovery': {
      id: '/spaces/license-manager/_saasLayout/discovery'
      path: '/discovery'
      fullPath: '/spaces/license-manager/discovery'
      preLoaderRoute: typeof SpacesLicenseManagerSaasLayoutDiscoveryRouteImport
      parentRoute: typeof SpacesLicenseManagerSaasLayoutRoute
    }
  }
}

interface SpacesExternalRouteRouteChildren {
  SpacesExternalClassicRoute: typeof SpacesExternalClassicRoute
  SpacesExternalIntegrationsRoute: typeof SpacesExternalIntegrationsRoute
}

const SpacesExternalRouteRouteChildren: SpacesExternalRouteRouteChildren = {
  SpacesExternalClassicRoute: SpacesExternalClassicRoute,
  SpacesExternalIntegrationsRoute: SpacesExternalIntegrationsRoute,
}

const SpacesExternalRouteRouteWithChildren =
  SpacesExternalRouteRoute._addFileChildren(SpacesExternalRouteRouteChildren)

interface SpacesLicenseManagerSaasLayoutRouteChildren {
  SpacesLicenseManagerSaasLayoutDiscoveryRoute: typeof SpacesLicenseManagerSaasLayoutDiscoveryRoute
  SpacesLicenseManagerSaasLayoutIndexRoute: typeof SpacesLicenseManagerSaasLayoutIndexRoute
}

const SpacesLicenseManagerSaasLayoutRouteChildren: SpacesLicenseManagerSaasLayoutRouteChildren =
  {
    SpacesLicenseManagerSaasLayoutDiscoveryRoute:
      SpacesLicenseManagerSaasLayoutDiscoveryRoute,
    SpacesLicenseManagerSaasLayoutIndexRoute:
      SpacesLicenseManagerSaasLayoutIndexRoute,
  }

const SpacesLicenseManagerSaasLayoutRouteWithChildren =
  SpacesLicenseManagerSaasLayoutRoute._addFileChildren(
    SpacesLicenseManagerSaasLayoutRouteChildren,
  )

interface SpacesLicenseManagerRouteChildren {
  SpacesLicenseManagerSaasLayoutRoute: typeof SpacesLicenseManagerSaasLayoutRouteWithChildren
}

const SpacesLicenseManagerRouteChildren: SpacesLicenseManagerRouteChildren = {
  SpacesLicenseManagerSaasLayoutRoute:
    SpacesLicenseManagerSaasLayoutRouteWithChildren,
}

const SpacesLicenseManagerRouteWithChildren =
  SpacesLicenseManagerRoute._addFileChildren(SpacesLicenseManagerRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SpacesExternalRouteRoute: SpacesExternalRouteRouteWithChildren,
  Spaces404Route: Spaces404Route,
  SpacesCheckMailRoute: SpacesCheckMailRoute,
  SpacesClassicRoute: SpacesClassicRoute,
  SpacesConnectRoute: SpacesConnectRoute,
  SpacesSettingsRoute: SpacesSettingsRoute,
  SpacesTemplateRoute: SpacesTemplateRoute,
  SpacesTemplatesListRoute: SpacesTemplatesListRoute,
  SpacesTicketRoute: SpacesTicketRoute,
  SpacesTrialRoute: SpacesTrialRoute,
  SpacesIndexRoute: SpacesIndexRoute,
  SpacesauthForgotPasswordRoute: SpacesauthForgotPasswordRoute,
  SpacesauthLoginRoute: SpacesauthLoginRoute,
  SpacesauthLogoutRoute: SpacesauthLogoutRoute,
  SpacesLicenseManagerRoute: SpacesLicenseManagerRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
